import { FC } from 'react'

import { Image } from '~ui'

import styles from './EventsList.module.scss'

interface EventsListHeaderProps {
  title: string
  subtitle: string
  imageSrc: string
}

const Header: FC<EventsListHeaderProps> = ({ imageSrc, title, subtitle }) => (
  <div className={styles.header}>
    <Image height={75} width={75} src={imageSrc} rounded />
    <div className={styles.desc}>
      <h1 className={styles.title}>{title}</h1>
      <h2 className={styles.subtitle}>{subtitle}</h2>
    </div>
  </div>
)

export default Header
